import React from "react";

import FileImport from "./file_import";
import Router from "./router";
import { useAppSelector, useDatabase } from "web/hooks";
import { getAllObservations } from "web/app_slice";

import classes from './app.module.css';

const App = () => {
  const allObservations = useAppSelector(getAllObservations);
  // TODO: make a more sensible div as the content wrapper?

  return <>
    <div className={ classes.root }>
      <nav className={ classes.nav }>
        <a href='#'>Birding Days</a>
        <hr className={ classes.vr } />
        <div className={ classes.navLinks }>
          <a href="#/cal">Calendar</a>
          <a href="#/birds">Birds</a>
          <a href="#/map">Map</a>
          <a href="#/import">Import</a>
        </div>
      </nav>

      <hr />

      <div className={ classes.content }>
        { allObservations.length > 0 ? <Router /> : <FileImport /> }
      </div>
    </div>
  </>;
}

export default App;

const Sidebar = () => {
  const database = useDatabase();

  return <a href='#/import' onClick={ async () => {
    localStorage.clear(); // TODO: remove eventually
    await database.clearObservations();
    document.location.href = "/"; // TODO: This causes some weird flicker too...
  } }>Reset</a>
}
